import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Ar from "../../assets/images/ar.png";
import Eng from "../../assets/images/eng.png";

import { SESSION_STORAGE_SELECTED_LOCALE } from "../../utils/constants";
import {
  selectedLocale,
  setSelectedLocale,
} from "../../store/slices/common/slice";

import { Image } from "./LocaleSelection.styles";

const LocaleSelection = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";
  const location = useLocation();

  const handleLocaleChange = (locale) => {
    localStorage.setItem(SESSION_STORAGE_SELECTED_LOCALE, locale);
    dispatch(setSelectedLocale(locale));
    i18n.changeLanguage(locale);

    const newPath = location?.search
      ? `/${locale}${location.pathname}${location.search}`
      : `/${locale}${location.pathname}`;
    window.history.replaceState({}, "", newPath);
    window.location.reload();
  };

  return ar ? (
    <Image
      src={Eng}
      alt="English Language"
      onClick={() => handleLocaleChange("en")}
    />
  ) : (
    <Image
      src={Ar}
      alt="Arabic Language"
      onClick={() => handleLocaleChange("ar")}
    />
  );
};

export default LocaleSelection;
